'use strict';

var React = require('react');
var index = require('./index-e4462b0a.js');
require('tslib');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-intl');
require('react-dom');
require('react-hook-form');

const theme$1 = index.createTheme(index.theme$1, {
    components: {
        MuiBadge: {
            styleOverrides: {
                root: {
                    width: 'fit-content',
                },
                badge: {
                    top: 0,
                    right: 0,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                multiple: true,
                value: [],
            },
        },
    },
});

const theme = index.createTheme(index.theme, {
    components: {
        MuiBadge: {
            styleOverrides: {
                root: {
                    width: 'fit-content',
                },
                badge: {
                    top: 0,
                    right: 0,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                multiple: true,
                value: [],
            },
        },
    },
});

const renderText = (selected, options) => {
    const formattedSelected = selected.map((value) => {
        const selectedOption = index.findSelectedOption(options, value);
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) || '';
    });
    return formattedSelected.join(', ');
};

const useMultiSelectHook = ({ id, displayValue, placeholder, name, value, renderValue, options, }) => {
    const selectRef = React.useRef(null);
    const [showBadge, setShowBadge] = React.useState(false);
    React.useLayoutEffect(() => {
        var _a;
        if (value && (value === null || value === void 0 ? void 0 : value.length) > 1 && ((_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.children)) {
            const { clientWidth, scrollWidth } = selectRef.current.children[0];
            if (clientWidth < scrollWidth) {
                setShowBadge(true);
            }
            else if (showBadge) {
                setShowBadge(false);
            }
        }
        else if (showBadge) {
            setShowBadge(false);
        }
    }, [showBadge, value]);
    const handleRenderValue = React.useCallback((selected) => {
        let returnValue = placeholder;
        const selectedValue = selected;
        if (renderValue) {
            returnValue = renderValue(selectedValue, options);
        }
        else if (displayValue) {
            returnValue = selectedValue.join(', ');
        }
        else if (selected === null || selected === void 0 ? void 0 : selected.length) {
            returnValue = renderText(selectedValue, options);
        }
        return returnValue;
    }, [displayValue, options, placeholder, renderValue]);
    const inputId = id !== null && id !== void 0 ? id : `${name}_multiSelect`;
    const labelId = `${name}_label`;
    const helperTextId = `${name}_helperText`;
    return {
        handleRenderValue,
        helperTextId,
        inputId,
        labelId,
        selectRef,
        showBadge,
    };
};

const NO_PREFERENCE_UUID = 'noPreference';
const NO_PREFERENCE_OPTION = {
    value: NO_PREFERENCE_UUID,
    text: 'No Preference',
    disabled: false,
};
const useNoPreferenceSelectionHook = ({ value, onChange, options, noPreferenceOptionEnabled, noPreferenceOption, }) => {
    var _a;
    const finalNoPreferenceOption = noPreferenceOption !== null && noPreferenceOption !== void 0 ? noPreferenceOption : NO_PREFERENCE_OPTION;
    const noPreferenceValue = (_a = noPreferenceOption === null || noPreferenceOption === void 0 ? void 0 : noPreferenceOption.value) !== null && _a !== void 0 ? _a : NO_PREFERENCE_UUID;
    const isNoPreferenceOptionSelected = value
        ? !index.isNil(value.find((o) => o === noPreferenceValue))
        : false;
    const didMountRef = React.useRef(false);
    React.useEffect(() => {
        if (didMountRef.current && isNoPreferenceOptionSelected && onChange) {
            onChange([noPreferenceValue]);
        }
        didMountRef.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNoPreferenceOptionSelected]);
    const optionsWithNoPreference = [
        finalNoPreferenceOption,
    ].concat(options);
    const handleDisablingOptionsWhenNoPreferenceSelected = React.useCallback((value) => noPreferenceOptionEnabled
        ? isNoPreferenceOptionSelected && value !== noPreferenceValue
        : false, [isNoPreferenceOptionSelected, noPreferenceOptionEnabled, noPreferenceValue]);
    return {
        isNoPreferenceOptionSelected: noPreferenceOptionEnabled
            ? isNoPreferenceOptionSelected
            : false,
        handleDisablingOptionsWhenNoPreferenceSelected,
        optionsWithNoPreference,
    };
};

/** https://mui.com/components/selects/ */
const MultiSelect = React.forwardRef(({ InputLabelProps, IconComponent, autoWidth, checkmarkIcon, checkmarks, disabled, displayEmpty, displayValue, error, focused, fullWidth, helperText, label, labelAction, margin, name, noPreferenceOptionEnabled, noPreferenceOption, onChange = () => { }, onClose = () => { }, options: baseOptions = [], placeholder, readOnly, renderValue, required, selectAllOption, sx, value, excludeFromSelectAll = [], onBlur, }, ref) => {
    const { optionsWithNoPreference, isNoPreferenceOptionSelected, handleDisablingOptionsWhenNoPreferenceSelected, } = useNoPreferenceSelectionHook({
        noPreferenceOptionEnabled,
        noPreferenceOption,
        value,
        onChange,
        options: baseOptions,
    });
    const options = noPreferenceOptionEnabled
        ? optionsWithNoPreference
        : baseOptions;
    const { handleRenderValue, helperTextId, inputId, labelId, selectRef, showBadge, } = useMultiSelectHook({
        displayValue,
        placeholder,
        value,
        name,
        label,
        renderValue,
        options,
    });
    const handleSelectAll = (event) => {
        event.stopPropagation();
        const allOptions = options === null || options === void 0 ? void 0 : options.map(({ value }) => value);
        const filtered = allOptions.filter((value) => !excludeFromSelectAll.includes(value));
        onChange(filtered);
    };
    const getSizeAll = () => {
        const size = options.length - excludeFromSelectAll.length;
        return size;
    };
    return (React.createElement(index.MultiThemeProvider, { fortressTheme: theme$1, portalTheme: theme }, (themeName) => (React.createElement(index.MuiFormControl, { disabled: disabled, error: error, focused: focused, fullWidth: fullWidth, margin: margin, required: required, sx: sx },
        label && (React.createElement(index.SingleSelectLabel, Object.assign({}, InputLabelProps, { disabled: disabled, error: error, focused: focused, htmlFor: inputId, id: labelId, label: label, labelAction: labelAction, readOnly: readOnly, required: required }))),
        React.createElement(index.Badge, { badgeContent: (value === null || value === void 0 ? void 0 : value.length) || '', color: 'primary', invisible: !showBadge, sx: {
                width: fullWidth ? '100%' : 'fit-content',
                // @ts-ignore
                transition: sx === null || sx === void 0 ? void 0 : sx.transition,
                // @ts-ignore
                opacity: sx === null || sx === void 0 ? void 0 : sx.opacity,
            } },
            React.createElement(index.MuiSelect, { ref: selectRef, IconComponent: IconComponent, name: name, autoWidth: autoWidth, displayEmpty: displayEmpty || !!(placeholder === null || placeholder === void 0 ? void 0 : placeholder.length), disabled: disabled, label: label, labelId: labelId, id: inputId, readOnly: readOnly, value: value, onChange: ({ target: { value } }) => {
                    onChange(value);
                }, onClose: onClose, input: React.createElement(index.OutlinedInput, { ref: ref }), inputProps: {
                    name,
                    'aria-label': labelId,
                }, renderValue: handleRenderValue, onBlur: onBlur },
                React.createElement(index.Collapse, { in: selectAllOption },
                    React.createElement("div", null,
                        React.createElement(index.MenuItem, { sx: {
                                color: 'primary.dark',
                                fontWeight: 400,
                            }, disabled: !(options === null || options === void 0 ? void 0 : options.length) ||
                                (value === null || value === void 0 ? void 0 : value.length) === options.length ||
                                (value === null || value === void 0 ? void 0 : value.length) === getSizeAll(), onClick: handleSelectAll }, `Select All (${getSizeAll() || 0})`),
                        React.createElement(index.Divider, null))),
                options.map((option) => {
                    const selected = (value !== null && value !== void 0 ? value : []).includes(option.value);
                    const customCheckMarkIcon = checkmarkIcon
                        ? { checkedIcon: checkmarkIcon }
                        : {};
                    return (React.createElement(index.MenuItem, { key: option.value, disabled: option.disabled ||
                            handleDisablingOptionsWhenNoPreferenceSelected(option.value), value: option.value },
                        checkmarks && (React.createElement(index.Checkbox, Object.assign({ checked: selected, label: '' }, customCheckMarkIcon))),
                        option.text));
                }),
                React.createElement(index.Collapse, { in: !isNoPreferenceOptionSelected },
                    React.createElement("div", null,
                        React.createElement(index.Divider, { sx: { marginTop: 1, marginBottom: 1 } }),
                        React.createElement(index.MenuItem, { sx: {
                                color: 'secondary.dark',
                                fontWeight: 400,
                            }, disabled: !(value === null || value === void 0 ? void 0 : value.length), onClick: () => onChange([]) }, `Clear All (${(value === null || value === void 0 ? void 0 : value.length) || 0}) Selected`))))),
        React.createElement(index.FormHelperText, { "data-testid": 'helperText', disabled: disabled, error: error, required: required, id: helperTextId }, index.determineHelperText({ themeName, required, helperText }))))));
});
MultiSelect.displayName = 'MultiSelect';
MultiSelect.defaultProps = {
    disabled: false,
    displayValue: false,
    placeholder: 'Select all that apply',
    options: [],
    value: [],
    name: '',
    checkmarks: true,
    fullWidth: true,
    onChange: () => { },
    excludeFromSelectAll: [],
    // @ts-ignore
    IconComponent: index.SingleSelect === null || index.SingleSelect === void 0 ? void 0 : index.SingleSelect.defaultProps.IconComponent,
};

exports.default = MultiSelect;
